import request from '@/utils/request';

// 商家端登录
export function shopLogin(data) {
    return request({
        url: '/shop/api/login_v2',
        method: 'post',
        data: data,
    });
}
// 获取商家信息
export function get_clerk_data(data) {
    return request({
        url: '/shop/index/get_clerk_data',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}
// 获取核销记录
export function get_write_record(data) {
    return request({
        url: '/shop/index/get_write_record',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}

// 获取商品信息
export function get_write_goods_info(data) {
    return request({
        url: '/shop/index/get_write_goods_info',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}

// 核销商品
export function write_goods(data) {
    return request({
        url: '/shop/index/write_goods',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}

// 核销商品
export function get_statistics_analysis(data) {
    return request({
        url: '/shop/index/get_statistics_analysis',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}
// 核销商品
export function get_verified_record(data) {
    return request({
        url: '/shop/index/get_verified_record',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}